import ExternalFormDto from '../../DTOs/ExternalForm/ExternalFormDto';
import MultiMeasureFormDto from '../../DTOs/Program/MultiMeasureForm/MultiMeasureFormDto';
import MultiMeasureFormListDto from '../../DTOs/Program/MultiMeasureForm/MultiMeasureFormListDto';
import { apiCall } from '../api';

export const multiMeasureCreateOrEditForm = async (isEdit, dto) => {
    const url = isEdit ? 'MultiMeasureForm/update' : 'MultiMeasureForm/create';
    let response = await apiCall(url, {
        method: isEdit ? 'PUT' : 'POST',
        body: dto.stringify(),
    });
    return new MultiMeasureFormDto(response.result);
};

export const getMultiMeasureFormsByProgramId = async (programId) => {
    const url = `MultiMeasureForm/getByProgram/${programId}`;
    let response = await apiCall(url);
    return new MultiMeasureFormListDto(response.result);
};

export const getMultiMeasureFormById = async (id) => {
    const url = `MultiMeasureForm/${id}`;
    let response = await apiCall(url);
    return new MultiMeasureFormDto(response.result);
};

export const getmultiMeasureDataForm = async (multiMeasureFormId) => {
  const url = `MultiMeasureForm/${multiMeasureFormId}/getExternalId`;
  let response = await apiCall(url);
  return new ExternalFormDto(response.result);
}


